import axios from 'axios';
import { postData } from './axiosUtils';

const mobileApplicationReleaseProfileService = {
  list: () => {
    return axios
      .get(`/api/mobileApplicationReleaseProfile/list`)
      .then((response) => response.data);
  },
  get: (id: number) => {
    return axios
      .get(`/api/mobileApplicationReleaseProfile/details/${id}`)
      .then((response) => response.data);
  },
  create: (entity: any) => {
    return postData({
      url: `/api/mobileApplicationReleaseProfile/create`,
      data: entity,
    }).then((response) => response);
  },
  update: (entity: any) => {
    return postData({
      url: `/api/mobileApplicationReleaseProfile/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => response);
  },
  delete: (id: number) => {
    return postData({
      url: `/api/mobileApplicationReleaseProfile/delete/${id}`,
      method: 'DELETE',
    }).then((response) => response);
  },
  rotateBuildApiKey: (id: number) => {
    return postData({
      url: `/api/mobileApplicationReleaseProfile/rotateBuildApiKey/${id}`,
      method: 'POST',
    }).then((response) => response);
  },
  uploadBuildConfigFile: (payload: {
    kind: number;
    fileName: string;
    contentBase64: string;
  }) => {
    return postData({
      url: `/api/mobileApplicationReleaseProfile/uploadBuildConfigFile`,
      data: payload,
      method: 'POST',
    }).then((response) => response);
  },
};

export default mobileApplicationReleaseProfileService;
